import React from "react";

// The app's only switch (mission wizard, schedule day, job template risks): use it rather than
// a copy. A native <button> gets Space/Enter activation and focus for free, and can be named by
// a <label htmlFor={id}>, which also makes the label text clickable.
// `size="sm"`: 48×28 instead of 56×32.
const SIZES = {
    md: { track: "h-8 w-14", knob: "h-6 w-6", on: "translate-x-7" },
    sm: { track: "h-7 w-12", knob: "h-5 w-5", on: "translate-x-6" },
};

const Switch = ({
    id,
    checked,
    onChange,
    disabled = false,
    ariaLabel,
    ariaDescribedBy,
    size = "md",
}) => {
    const sizeClasses = SIZES[size] || SIZES.md;
    return (
        <button
            type="button"
            id={id}
            role="switch"
            aria-checked={!!checked}
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={`relative inline-flex ${sizeClasses.track} shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-300 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
                checked ? "bg-yellow-500" : "bg-gray-200"
            }`}
        >
            <span
                aria-hidden="true"
                className={`inline-block ${sizeClasses.knob} rounded-full bg-white shadow transform transition-transform duration-200 ease-in-out ${
                    checked ? sizeClasses.on : "translate-x-1"
                }`}
            />
        </button>
    );
};

export default Switch;
